<template>
  <div class="filtered-tab">
    <div class="filtered-tab__tabs container">
      <tab-filter
        :tabs="regions"
        :dictionary="{ ...dictionary, all: 'All' }"
        @update:final-query="tabQuery = $event"
        :update-query="false"
        :use-all="false"
        query="region"
        queryable-data="region"
      >
        <template #default="{ active, click, tabs, move }">
          <slot
            name="tab-item"
            :active="active"
            :click="click"
            :tabs="tabs"
            :move="move"
          ></slot>
        </template>
      </tab-filter>
    </div>
    <slot
      :items="selectedItems"
      :dictionary="dictionary"
      :ckey="carouselKey"
      :active="currentActive"
    ></slot>
  </div>
</template>
  
<script>
import { uuid } from "../../../../utils/uuid";
import { createLocationObject, createTabObject } from "./filteredTabDataConverter";
export default {
  name: "filtered-tab",
  props: {
    items: {
      type: Array,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    orderRegions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tabQuery: {},
      carouselKey: uuid(),
      currentTab: undefined
    };
  },
  watch: {
    tabQuery: {
      handler: function (newValue) {
        this.currentTab = this.tabQuery;
        //this.filter();
        // Force Vue to treat the carousel component as new everytime the query is updated, so slick can recognize the updated slides.
        this.carouselKey = uuid();
      },
      deep: true
    },
  },
  computed: {
    regions() {
      return this.orderRegions.map(r => createTabObject(r));
    },
    locations() {
      return this.items.map(loc => createLocationObject(loc));
    },
    selectedItems() {
      if (!this.currentTab || !this.currentTab.region) return this.locations;

      return this.locations.filter(location => {
        if (!location.region) return false;
        return location.region.indexOf(this.currentTab.region) > -1;
      });
    },
    currentActive () {
      return this.currentTab ? this.currentTab.region : undefined;
    }
  },
  methods: {
  },
};
</script>
  